import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import {
  Modal,
  Header,
  Body,
  Footer,
  Close
} from "MODULES/shared/components/Modal";
import api from "APP_ROOT/api";
import Table from "./Table";

function modalTitle(creating, editing) {
  if (creating) return "Add a Quarterly Goal";
  if (editing) return "Edit Quarterly Goal";
  return "Quarterly Goals";
}

function QuarterlyGoalsModal({ editing, close, goals, searchQuarterlyGoals }) {
  const [creatingQuarterlyGoal, setCreatingQuarterlyGoal] = useState(false);
  const [editingQuarterlyGoal, setEditingQuarterlyGoal] = useState(null);
  const title = modalTitle(creatingQuarterlyGoal, editingQuarterlyGoal);

  return (
    <Modal open={editing} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">{title}</h4>
      </Header>
      <Body>
        <Table
          creatingQuarterlyGoal={creatingQuarterlyGoal}
          setCreatingQuarterlyGoal={setCreatingQuarterlyGoal}
          editingQuarterlyGoal={editingQuarterlyGoal}
          setEditingQuarterlyGoal={setEditingQuarterlyGoal}
          searchQuarterlyGoals={searchQuarterlyGoals}
          closeModal={close}
          goals={goals}
        />
      </Body>
      {editingQuarterlyGoal || creatingQuarterlyGoal ? (
        <Footer style={{ display: "none" }} />
      ) : (
        <Footer>
          <Button onClick={close}>Cancel</Button>
          <Button
            bsStyle={creatingQuarterlyGoal ? "danger" : "primary"}
            onClick={() => setCreatingQuarterlyGoal(!creatingQuarterlyGoal)}
          >
            Add Goal
          </Button>
        </Footer>
      )}
    </Modal>
  );
}

QuarterlyGoalsModal.propTypes = {
  editing: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  goals: PropTypes.shape({}),
  searchQuarterlyGoals: PropTypes.func.isRequired
};

export default function QuarterlyGoals() {
  const [editing, setEditing] = useState(false);
  const [goals, setGoals] = useState([]);
  const searchQuarterlyGoals = () => {
    api.quarterlyGoals.search({}).then(resp => {
      setGoals(resp.data.results);
      setEditing(true);
    });
  };

  return (
    <React.Fragment>
      <a style={{ cursor: "pointer" }} onClick={searchQuarterlyGoals}>
        Quarterly Goals
      </a>
      <QuarterlyGoalsModal
        editing={editing}
        close={() => setEditing(false)}
        goals={goals}
        searchQuarterlyGoals={searchQuarterlyGoals}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./app/modules/QuarterlyGoals/QuarterlyGoals.jsx